'use client';

import dynamic from 'next/dynamic';
import ProcessTimeline from './ProcessTimeline';
import SocialProof from './SocialProof';
import CTASection from './CTASection';
import AnimationErrorBoundary from '@/components/AnimationErrorBoundary';

// Dynamically import all components that use browser-only packages (ogl, gsap)
// ssr: false ensures webpack never tries to initialize their chunk factories in Node.js
const HeroSection = dynamic(() => import('./HeroSection'), { ssr: false });
const MagicBento = dynamic(() => import('./MagicBento'), { ssr: false });
const TestimonialCarousel3D = dynamic(() => import('./TestimonialCarousel3D'), { ssr: false });

export default function HomepageClient() {
  return (
    <main className="ml-20">
      <AnimationErrorBoundary componentName="HeroSection" silent>
        <HeroSection />
      </AnimationErrorBoundary>
      <section className="py-16 lg:py-24 bg-gradient-to-b from-background to-[#0a0a0a]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-6">
              Complete AI-oplossingen voor{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
                elk bedrijfsproces
              </span>
            </h2>
            <p className="text-lg text-muted-foreground">
              Van klantenservice tot marketing - ontdek hoe AI jouw bedrijf kan transformeren met meetbare resultaten.
            </p>
          </div>
          <AnimationErrorBoundary componentName="MagicBento">
            <MagicBento />
          </AnimationErrorBoundary>
        </div>
      </section>
      <AnimationErrorBoundary componentName="ProcessTimeline">
        <ProcessTimeline />
      </AnimationErrorBoundary>
      <AnimationErrorBoundary componentName="TestimonialCarousel3D">
        <TestimonialCarousel3D />
      </AnimationErrorBoundary>
      <AnimationErrorBoundary componentName="SocialProof">
        <SocialProof />
      </AnimationErrorBoundary>
      <CTASection />
    </main>
  );
}
